import React from "react";
import { Col } from "react-bootstrap";
import AllNotesContainer from "../client-activity/tabs-container/notes-container";
import TabSelector from "../../../library/tab-selector";
import "./style.scss";
import { UpperRow } from "../../../library/upper-row";
import Text from "../../../library/text";

const Index = () => {
  const tabs = [
    {
      key: "notes",
      title: "Notater",
      content: <AllNotesContainer />,
    },
  ];

  return (
    <Col md={5} className="dashboard-single-client-right-container">
      <Col className="inner-dashboard-single-client-right-container">
        <UpperRow title="Aktivitet" />
        <div className="single-client-description-container">
          <Text>
            Nedenfor kan du få en full oversikt over kunden din og se all
            aktivitet som omhandler salg, kommunikasjon og andre notater.
          </Text>
        </div>
        <TabSelector defaultValue="notes" items={tabs} />
      </Col>
    </Col>
  );
};

export default Index;
